<template>
  <div id="wrapper" v-if="timeoff_management">
    <div id="content-wrapper">
      <!-- #region TITLE TIME-OFF MANAGEMENT -->
      <div class="time_off_management_header">
        <b-row style="max-width: 1800px; margin: auto;">
          <b-col cols="4" style="">
            <div class="form-inline" style="width: 100%">
              <b-form-select
                v-model="year_selected"
                style="padding:3px 30px 3px 6px; width: 100px; min-width: 100px; max-width: 100px; margin-right: 5px;"
                :options="optionsYear"
                value-field="value"
                text-field="text"
                @change="queryTimeOff"
              >
                <!-- <template #first>
                  <b-form-select-option value="-1">
                    All
                  </b-form-select-option>
                </template> -->
              </b-form-select>
              <b-form-select
                v-model="month_selected"
                style="padding:3px 30px 3px 6px; width: 120px; min-width: 120px; max-width: 120px; margin-right: 5px;"
                :options="optionsMonth"
                value-field="value"
                text-field="text"
                @change="queryTimeOff"
              >
                <template #first>
                  <b-form-select-option value="0">
                    All
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="timeoff_type_selected"
                style="padding:3px 30px 3px 6px; width: 150px; min-width: 150px; max-width: 150px; margin-right: 5px;"
                :options="TO_type_list"
                value-field="id"
                text-field="pickListValue"
                @change="queryTimeOff"
              >
              </b-form-select>
              <b-form-select
                v-model="timeoff_status_selected"
                style="padding:3px 30px 3px 6px; width: 150px; min-width: 150px; max-width: 150px; margin-right: 5px;"
                :options="TO_status_list"
                value-field="id"
                text-field="pickListValue"
                @change="queryTimeOff"
              >
              </b-form-select>
              <button
                class="btn border-0 button--pandora"
                style="margin-right: 5px;"
                @click.prevent="excelReport"
              >
                <i class="far fa-file-excel"></i>
                <span id="btn-time-off-management-type-1"> Export</span>
                <!-- Xuất excel -->
              </button>
              <button
                id="resend-pending-mail"
                class="btn border-0 button--pandora"
                @click.prevent="ReSendPendingTimeOffRequestMail"
                :style="[
                  is_admin_account
                    ? {
                        display: 'unset',
                      }
                    : {
                        display: 'none',
                      },
                ]"
              >
                <i class="fas fa-envelope"></i>
                <span id="btn-time-off-management-type-2"> ReSend Mail</span>
              </button>
              <b-tooltip target="resend-pending-mail" triggers="hover">
                ReSend <b>Pending</b> TimeOff Request Mail!
              </b-tooltip>
            </div>
          </b-col>
          <b-col cols="8" style="">
            <div class="form-inline" style="width: 100%">
              <b-form-input
                class="mr-2"
                style="flex-grow: 1; display: inline-block; width: auto; vertical-align: middle;"
                v-model="employee_search"
                placeholder="Search by Employee Name"
                @keydown.enter.prevent="queryTimeOff"
              ></b-form-input>
              <button
                class="btn btn-outline-dark border-0 mr-2"
                @click.prevent="queryTimeOff"
              >
                <i class="fas fa-search"></i>
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--#endregion -->

      <!-- #region TIME-OFF MANAGEMENT -->
      <div id="time_off_management_fluid" class="container-fluid">
        <div class="time_off_management">
          <div class="justify-content-start" style="height: 100%;">
            <!-- #region Header -->
            <b-row class="" style="padding: 0px; margin: 0px;">
              <b-col cols="12" style="padding:0px; float: left;">
                <div
                  style="border: 0px solid #ddd; border-radius: 5px 5px 0px 0px; background: #c8c8c8; height: 50px;  justify-content: center; align-items: center; display: flex;"
                >
                  <img
                    id="megroup_logo"
                    src="../assets/Logo/MeGroup_logo_Black.png"
                    class="d-inline-block align-top"
                    alt="MeGroup"
                    width="50px"
                  />
                </div>
              </b-col>
            </b-row>
            <!--#endregion -->
            <!-- #region Time-off management Table -->
            <b-row class="" style="padding: 7px 0px 0px 0px; margin: 0px;">
              <b-col cols="12" style="float: right; padding:0px;">
                <b-table
                  id="emp-table"
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  bordered
                  sticky-header="true"
                  :no-border-collapse="true"
                  :busy="isBusy"
                  table-variant="light"
                  :fields="TO_mgt_fields"
                  :items="TO_mgt_items"
                  selectable
                  select-mode="single"
                  @row-dblclicked="onRowDBClicked"
                >
                  <template #cell(STT)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template v-slot:cell(fromDate)="data">{{
                    $convert_date_string(data.item.fromDate)
                  }}</template>
                  <template v-slot:cell(toDate)="data">{{
                    $convert_date_string(data.item.toDate)
                  }}</template>
                  <template v-slot:cell(numOfTimeOff)="data">{{
                    data.item.numOfTimeOff
                  }}</template>
                  <template v-slot:cell(reason)="data">{{
                    data.item.reason
                  }}</template>
                  <template v-slot:cell(taskduringwfh)="data">{{
                    data.item.taskduringwfh
                  }}</template>
                  <template v-slot:cell(timeOffType)="data">
                    <b-badge
                      :variant="setVariantByTimeOffType(data.item.timeOffType)"
                      style="width: 117px; white-space: pre-wrap;"
                    >
                      {{
                        findTimeOffType(TO_type_list, data.item.timeOffType)
                      }}</b-badge
                    >
                  </template>
                  <template v-slot:cell(timeOffStatus)="data">
                    <b-badge
                      :variant="
                        setVariantByTimeOffStatus(data.item.timeOffStatus)
                      "
                      style="width: 117px; white-space: pre-wrap;"
                    >
                      {{
                        findTimeOffStatus(
                          TO_status_list,
                          data.item.timeOffStatus
                        )
                      }}</b-badge
                    >
                  </template>
                  <template v-slot:cell(action)="data">
                    <div>
                      <b-link
                        class="text-primary"
                        href="#"
                        @click="onRowDBClicked(data.item)"
                      >
                        <i class="fas fa-info-circle"></i>
                      </b-link>
                    </div>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-2"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #empty="">
                    <div class="text-center text-secondary my-2">
                      No data
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <!--#endregion -->
          </div>
        </div>
      </div>
      <!--#endregion -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TimeOffManagement",
  components: {},
  data() {
    return {
      isBusy: false,
      isDetailBusy: false,
      //#region Search
      year_selected: -1,
      month_selected: 0,
      timeoff_type_selected: null,
      timeoff_status_selected: null,
      employee_search: null,
      // working_status_search: 0, //default is Working

      emp_status_list: [],
      working_status_list: /*employee status group by official staff*/ [
        {
          id: null,
          pickListType: "workingstatus",
          pickListValue: "All",
        },
        {
          /*Employee Status: on working && probation && intern && collaborator*/
          id: 0,
          pickListType: "workingstatus",
          pickListValue: "Working",
        },
        {
          id: 67,
          pickListType: "workingstatus",
          pickListValue: "Quit job",
        },
        {
          id: 66,
          pickListType: "workingstatus",
          pickListValue: "Official staff",
        },
        {
          id: 68,
          pickListType: "workingstatus",
          pickListValue: "Probation",
        },
        {
          id: 2233,
          pickListType: "workingstatus",
          pickListValue: "Intern",
        },
        {
          id: 20303,
          pickListType: "workingstatus",
          pickListValue: "Collaborator",
        },
      ],
      TO_type_list: [],
      TO_status_list: [
        {
          id: null,
          pickListType: "tinhtrangduyet",
          pickListValue: "All",
        },
        {
          id: 0,
          pickListType: "tinhtrangduyet",
          pickListValue: "Awaiting approval",
        },
        {
          id: 1,
          pickListType: "tinhtrangduyet",
          pickListValue: "Approved",
        },
        {
          id: 2,
          pickListType: "tinhtrangduyet",
          pickListValue: "Declined",
        },
      ],
      //#endregion
      //#region Table Params
      TO_mgt_fields: /*TimeOff management with Employee List Fields*/ [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: { width: "20px", textAlign: "center" },
          tdClass: "text-center",
        },
        {
          key: "STT",
          label: "No.",
          thClass: "align-middle",
          thStyle: { width: "20px", textAlign: "center" },
          tdClass: "text-center",
        },
        {
          key: "employeeCode",
          label: "Code",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            textAlign: "center",
          },
          tdClass: "text-left",
        },
        {
          key: "employeeFullname",
          label: "Full Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "230px",
            minWidth: "230px",
            maxWidth: "230px",
            textAlign: "center",
          },
          tdClass: "text-left",
        },
        {
          key: "fromDate",
          label: "From Date",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "130px",
            minWidth: "130px",
            maxWidth: "130px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "toDate",
          label: "To Date",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "130px",
            minWidth: "130px",
            maxWidth: "130px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "numOfTimeOff",
          label: "Days",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "60px",
            minWidth: "60px",
            maxWidth: "60px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "reason",
          label: "Reason/Note",
          thClass: "align-middle",
          thStyle: {
            width: "280px",
            minWidth: "280px",
            textAlign: "center",
          },
        },
        {
          key: "taskduringwfh",
          label: "Task During WFH",
          thClass: "align-middle",
          thStyle: {
            width: "auto",
            minWidth: "280px",
            textAlign: "center",
          },
        },
        {
          key: "lineManagerFullname",
          label: "Line Manager",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "230px",
            minWidth: "230px",
            maxWidth: "230px",
            textAlign: "center",
          },
          tdClass: "text-left",
        },
        {
          key: "timeOffType",
          label: "Type",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "130px",
            minWidth: "130px",
            maxWidth: "130px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "timeOffStatus",
          label: "Status",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "130px",
            minWidth: "130px",
            maxWidth: "130px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
      ],
      TO_mgt_items: [] /*TimeOff management with Employee List*/,
      //#endregion
      optionsMonth: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
        { value: 13, text: "Quarter I" },
        { value: 14, text: "Quarter II" },
        { value: 15, text: "Quarter III" },
        { value: 16, text: "Quarter IV" },
      ],
      TO_employee: {
        employeeId: 0,
        employeeCode: "",
        employeeFullname: "",
        employeeEnName: "",
        employeeDeptId: 0,
        position: null,
        email: null,

        lineManagerId: 0,
        lineManagerCode: "",
        lineManagerFullname: "",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([axios.get("/api/picklist?q=loainghiphep")])
      .then(
        axios.spread((picklist) => {
          next((vm) =>
            vm.initData(
              picklist.data,
              null // not error
            )
          );
        })
      )
      .catch((err) => {
        next((vm) => vm.initData(null, null, null, err));
      });
  },
  beforeDestroy() {
    this.cancelRefreshDeviceTable();
  },
  created() {
    this.timer = setInterval(this.refreshDeviceTable, 60000);
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    timeoff_management() {
      return this.$store.getters.hasPermission("timeoff_management");
    },
    is_admin_account() {
      return this.$store.state.auth.name == "admin"; //this.$admin_account;
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      if (new Date().getMonth() >= 11) {
        result.push({ value: this_year + 1, text: this_year + 1 });
      }
      for (var i = this_year; i >= 2020; i--) {
        result.push({ value: i, text: i });
      }
      return result;
    },
  },
  mounted() {
    function calendar_change(type_) {
      /*eslint-disable-next-line no-console*/ //Comment remove no-console
      // console.log(document.documentElement.clientWidth);
      const btn_cal_t1 = document.querySelectorAll(
        "#btn-time-off-management-type-1"
      );
      const btn_cal_t2 = document.querySelectorAll(
        "#btn-time-off-management-type-2"
      );
      if (document.documentElement.clientWidth <= 800) {
        btn_cal_t1.forEach((element) => {
          element.style.display = "none";
        });
        btn_cal_t2.forEach((element) => {
          element.style.display = "none";
        });
      } else if (
        document.documentElement.clientWidth <= 1650 &&
        document.documentElement.clientWidth > 1200
      ) {
        btn_cal_t1.forEach((element) => {
          element.style.display = "unset";
        });
        btn_cal_t2.forEach((element) => {
          element.style.display = "none";
        });
      } else if (
        (document.documentElement.clientWidth <= 1200 &&
          document.documentElement.clientWidth > 800) ||
        btn_cal_t1[0].style.display == "none" ||
        btn_cal_t2[0].style.display == "none" ||
        type_ == "firstLoad"
      ) {
        btn_cal_t1.forEach((element) => {
          element.style.display = "unset";
        });
        btn_cal_t2.forEach((element) => {
          element.style.display = "unset";
        });
      }
    }
    calendar_change("firstLoad"); //run first load page
    window.addEventListener(
      "resize",
      function(event) {
        calendar_change("addEventListener");
      },
      true
    );
  },
  methods: {
    initData(picklists, err) {
      this.isBusy = true;
      if (err) {
        this.$toast.error(err.response.data, "Error", { timeout: 10000 });
        return;
      }
      picklists.forEach((picklist, index) => {
        switch (picklist.pickListType) {
          case "loainghiphep":
            if (picklist.pickListValue == "Phép") {
              this.TO_type_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Paid leave",
              });
            } else if (picklist.pickListValue == "Nghỉ không lương") {
              this.TO_type_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Unpaid leave",
              });
            } else {
              this.TO_type_list.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: picklist.pickListValue,
              });
            }
            break;
        }
      });
      this.TO_type_list.unshift({
        id: null,
        pickListType: "loainghiphep",
        pickListValue: "All",
      });

      this.year_selected = new Date().getFullYear();
      this.month_selected = new Date().getMonth() + 1;
      this.timeoff_type_selected = null;
      this.timeoff_status_selected = null;

      let query = Object.assign({}, this.$route.query);
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.q = this.getQuery();

      axios
        .get(`/api/timeoffrequest/management`, {
          params: query,
        })
        .then((res) => {
          this.isBusy = false;
          this.TO_mgt_items = res.data;
          if (!this.TO_mgt_items) return;
          return this.TO_mgt_items.map((item) => {
            item._rowVariant = this.getVariant(item.fromDate);
            return item;
          });
        })
        .catch((err) => {
          this.TO_mgt_items = [];
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {});
    },

    onRowDBClicked(row) {
      this.$router.push(`/time_off_request/${row.employeeCode}`);
    },

    //#region Query method
    queryTimeOff() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.q = this.getQuery();

      axios
        .get(`/api/timeoffrequest/management`, {
          params: query,
        })
        .then((res) => {
          this.isBusy = false;
          this.TO_mgt_items = res.data;
        })
        .catch((err) => {
          this.TO_mgt_items = [];
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {});
    },

    convertNullable(value) {
      if (value == null) return "";
      return value;
    },

    getQuery() {
      return (
        this.convertNullable(this.employee_search) +
        "|" +
        // this.convertNullable(this.reason_search) +
        // "|" +
        // this.convertNullable(this.taskduringwfh_search) +
        // "|" +
        this.convertNullable(this.timeoff_type_selected) +
        "|" +
        this.convertNullable(this.timeoff_status_selected)
      );
    },
    //#endregion

    //#region Export Time Off Report
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.q = this.getQuery();

      axios({
        method: "get",
        url: `/api/timeoffrequest/management/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    //#endregion

    //#region ReSend Pending TimeOff Request Mail
    ReSendPendingTimeOffRequestMail() {
      if (!this.is_admin_account) return;

      const payload = {};
      axios
        .post(
          "/api/timeoffrequest/resend_timeoff_request_pending?year=" +
            this.year_selected +
            "&month=" +
            this.month_selected,
          payload
        )
        .then((res) => {
          this.$toast.success("Resend mail successfully!", "Success", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error("Error", "Error", {
            timeout: 2000,
          });
        })
        .finally(() => {});
    },
    //#endregion
    //#region Find Method
    findTimeOffType(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },

    findTimeOffStatus(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    //#endregion

    //#region Set Color Method
    getVariant(value) {
      var dateU = new Date(value);
      var dateNow = new Date();

      if (dateU.getFullYear() != dateNow.getFullYear()) return "";
      if (dateU.getMonth() != dateNow.getMonth()) return "";
      if (dateU.getDate() != dateNow.getDate()) return "";
      return "hightlight";
    },

    setVariantByTimeOffType(value) {
      var variant = "primary";
      switch (value) {
        case this.$timeoff_type_paidleave:
          variant = "warning";
          break;
        case this.$timeoff_type_unpaidleave:
          variant = "success";
          break;
        case this.$timeoff_type_workfromhome:
          variant = "info";
          break;
        case this.$timeoff_type_statutoryleave:
          variant = "secondary";
          break;
      }
      return variant;
    },
    setVariantByTimeOffStatus(value) {
      var variant = "info";
      switch (value) {
        case this.$timeoff_status_awaiting_approval:
          variant = "primary";
          break;
        case this.$timeoff_status_approved:
          variant = "success";
          break;
        case this.$timeoff_status_declined:
          variant = "danger";
          break;
      }
      return variant;
    },
    //#endregion

    //#region Refresh Page Method
    refreshDeviceTable() {
      //   var temp = window.scrollY;
      //   // let query = Object.assign({}, this.$route.query);
      //   axios
      //     .get(
      //       `/api/timeoffrequest/employee/${this.employee.employeeId}/tracking`
      //       // ,{
      //       //   params: query,
      //       // }
      //     )
      //     .then((res) => {
      //       this.employeeTimeOffRequests = res.data;
      //     })
      //     .catch((err) => {
      //       this.$toast.error(err.response.data, "Error", { timeout: 3000 });
      //     })
      //     .finally(() => {
      //       window.scrollTo({
      //         top: temp,
      //       });
      //     });
    },

    cancelRefreshDeviceTable() {
      clearInterval(this.timer);
    },
    //#endregion
  },
};
</script>
<style scoped>
.button--pandora {
  color: #fff;
  background-color: #228b3a;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.button--pandora:hover {
  background-color: #1c682e;
}
</style>
<style>
.table-hightlight > td {
  background-color: #b1d9e4;
}
#emp-table .table-hover tbody tr:hover > td {
  background-color: #84c3d5;
}
.table-hover .table-hightlight:hover > td {
  background-color: #84c3d5;
}

#time_off_management_fluid div.card-body {
  padding: 15px;
}

#time_off_management_fluid .time_off_management {
  padding: 15px;
  color: #000;
  border-radius: 10px;
  background-color: #fff;
  width: 1800px;
  margin: auto;
}

.time_off_management_header {
  height: 56px;
  padding: 0.65rem 1rem;
  margin: 8px 16px 16px 16px;
  list-style: none;
  background-color: #fff;
  border-radius: 0.25rem;
  align-self: center;
  justify-content: center;
  justify-content: center;
}

.time_off_management_header .row .col-4 {
  width: 800px;
  max-width: 800px;
  min-width: 705px;
  flex: 0 0 50%;
}

.time_off_management_header .row .col-8 {
  width: calc(100% - 705px);
  max-width: 50%;
  min-width: 295px;
  flex: 0 0 calc(100% - 705px);
}

#time_off_management_fluid.container-fluid {
  height: calc(100% - 80px);
  overflow: auto;
}

#time_off_management_fluid .form-control {
  font-size: 1rem;
}

#time_off_management_fluid .table-responsive {
  margin-bottom: 0px;
}

@media (max-width: 1200px) {
  .time_off_management_header {
    height: unset;
  }
  .time_off_management_header .row .col-4 {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    flex: 0 0 100%;
  }
  .time_off_management_header .row .col-8 {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    flex: 0 0 100%;
  }
}

@media (max-width: 1835px) {
  #time_off_management_fluid .time_off_management {
    width: 100%;
  }
}

/*#region Scrollbar*/
#time_off_management_fluid .b-table-sticky-header {
  height: calc(100vh - 250px);
  max-height: unset;
}
#time_off_management_fluid::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.8);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#time_off_management_fluid::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#time_off_management_fluid::-webkit-scrollbar:horizontal {
  height: 10px;
  background-color: #f5f5f5;
}

#time_off_management_fluid::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}

#time_off_management_fluid::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}
/*#endregion Scrollbar*/
</style>
